var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasmIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.276,
    height: 33.015,
    viewBox: "0 0 52.276 33.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CD_Icons-08",
    "data-name": "CD Icons-08",
    transform: "translate(-16.281 -9.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10397",
    "data-name": "Group 10397",
    transform: "translate(64.843 39.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33217",
    "data-name": "Path 33217",
    d: "M873.877,541.3l-2.22.307a.052.052,0,0,0,0,.1l2.924.267Z",
    transform: "translate(-871.612 -541.3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10398",
    "data-name": "Group 10398",
    transform: "translate(65.752 40.195)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1865",
    "data-name": "Ellipse 1865",
    cx: 0.108,
    cy: 0.693,
    rx: 0.108,
    ry: 0.693,
    transform: "translate(0 0.216) rotate(-88.986)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10484",
    "data-name": "Group 10484",
    transform: "translate(20.333 36.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10399",
    "data-name": "Group 10399",
    transform: "translate(0 1.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33218",
    "data-name": "Path 33218",
    d: "M91.585,520.5H88.247a.607.607,0,0,0-.267.04l-.341.329c-.023.023.062.04.193.04h3.4a.571.571,0,0,0,.267-.04l.278-.329C91.8,520.517,91.71,520.5,91.585,520.5Z",
    transform: "translate(-87.636 -520.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10400",
    "data-name": "Group 10400",
    transform: "translate(4.084 1.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33219",
    "data-name": "Path 33219",
    d: "M162.153,520.5H160.1a.558.558,0,0,0-.261.04h0l-.278.329c-.017.023.068.04.2.04h2.089a.541.541,0,0,0,.261-.04h0l.238-.329C162.369,520.517,162.278,520.5,162.153,520.5Z",
    transform: "translate(-159.562 -520.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10401",
    "data-name": "Group 10401",
    transform: "translate(6.86 1.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33220",
    "data-name": "Path 33220",
    d: "M211,520.5h-2.05a.529.529,0,0,0-.255.04h0l-.233.329c-.017.023.074.04.2.04h2.089a.5.5,0,0,0,.255-.04h0l.193-.329C211.225,520.517,211.129,520.5,211,520.5Z",
    transform: "translate(-208.464 -520.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10402",
    "data-name": "Group 10402",
    transform: "translate(9.632 1.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33221",
    "data-name": "Path 33221",
    d: "M259.777,520.5h-2.05a.484.484,0,0,0-.25.04h0l-.193.329c-.011.023.079.04.21.04h2.089a.468.468,0,0,0,.25-.04h0l.153-.329C260,520.517,259.9,520.5,259.777,520.5Z",
    transform: "translate(-257.283 -520.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10403",
    "data-name": "Group 10403",
    transform: "translate(0.46 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33222",
    "data-name": "Path 33222",
    d: "M96.324,512.9a.714.714,0,0,0-.261.034l-.324.318c-.023.023.062.04.187.04h2.651a.559.559,0,0,0,.261-.04l.278-.318c.017-.023-.068-.034-.193-.034Z",
    transform: "translate(-95.735 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10404",
    "data-name": "Group 10404",
    transform: "translate(0.897 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33223",
    "data-name": "Path 33223",
    d: "M103.621,506.169h3.935a.654.654,0,0,0,.255-.034l.25-.3c.017-.017-.068-.034-.193-.034h-3.861a.7.7,0,0,0-.255.034l-.312.3C103.416,506.152,103.5,506.169,103.621,506.169Z",
    transform: "translate(-103.435 -505.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10405",
    "data-name": "Group 10405",
    transform: "translate(1.317 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33224",
    "data-name": "Path 33224",
    d: "M111.021,499.158h3.2a.638.638,0,0,0,.25-.034l.25-.29c.017-.017-.068-.034-.187-.034h-3.14a.636.636,0,0,0-.25.034l-.3.29C110.816,499.141,110.9,499.158,111.021,499.158Z",
    transform: "translate(-110.835 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10406",
    "data-name": "Group 10406",
    transform: "translate(3.788 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33225",
    "data-name": "Path 33225",
    d: "M154.892,512.9a.652.652,0,0,0-.255.034l-.273.318c-.017.023.068.04.193.04H156.6a.529.529,0,0,0,.255-.04l.238-.318c.017-.023-.074-.034-.2-.034Z",
    transform: "translate(-154.362 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10407",
    "data-name": "Group 10407",
    transform: "translate(6.506 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33226",
    "data-name": "Path 33226",
    d: "M202.432,513.292h2.044a.484.484,0,0,0,.25-.04l.2-.318c.011-.023-.079-.034-.2-.034h-2a.6.6,0,0,0-.25.034l-.233.318C202.216,513.275,202.3,513.292,202.432,513.292Z",
    transform: "translate(-202.236 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10408",
    "data-name": "Group 10408",
    transform: "translate(5.486 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33227",
    "data-name": "Path 33227",
    d: "M186.705,506.135l.21-.3c.011-.017-.074-.034-.193-.034h-1.964a.638.638,0,0,0-.25.034l-.244.3c-.017.023.068.034.193.034h2A.579.579,0,0,0,186.705,506.135Z",
    transform: "translate(-184.262 -505.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10409",
    "data-name": "Group 10409",
    transform: "translate(8.144 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33228",
    "data-name": "Path 33228",
    d: "M233.53,506.135l.17-.3c.011-.017-.079-.034-.2-.034h-1.97a.6.6,0,0,0-.244.034l-.2.3c-.011.023.074.034.2.034h2A.559.559,0,0,0,233.53,506.135Z",
    transform: "translate(-231.082 -505.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10410",
    "data-name": "Group 10410",
    transform: "translate(5.162 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33229",
    "data-name": "Path 33229",
    d: "M178.751,499.158h1.964a.58.58,0,0,0,.244-.034l.21-.29c.011-.017-.074-.034-.193-.034h-1.925a.6.6,0,0,0-.244.034l-.244.29C178.547,499.141,178.632,499.158,178.751,499.158Z",
    transform: "translate(-178.562 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10411",
    "data-name": "Group 10411",
    transform: "translate(7.77 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33230",
    "data-name": "Path 33230",
    d: "M224.688,498.834l-.2.29c-.011.017.074.034.193.034h1.964a.546.546,0,0,0,.238-.034l.17-.29c.011-.017-.074-.034-.193-.034h-1.925A.512.512,0,0,0,224.688,498.834Z",
    transform: "translate(-224.482 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10412",
    "data-name": "Group 10412",
    transform: "translate(1.722 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33231",
    "data-name": "Path 33231",
    d: "M118.144,492.446h1.925a.6.6,0,0,0,.244-.034l.255-.278c.017-.017-.062-.034-.182-.034H118.5a.623.623,0,0,0-.244.034l-.29.278C117.945,492.429,118.024,492.446,118.144,492.446Z",
    transform: "translate(-117.96 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10413",
    "data-name": "Group 10413",
    transform: "translate(4.282 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33232",
    "data-name": "Path 33232",
    d: "M165.409,492.412l.221-.278c.011-.017-.068-.034-.187-.034h-1.891a.587.587,0,0,0-.238.034l-.25.278c-.017.017.068.034.182.034h1.925A.546.546,0,0,0,165.409,492.412Z",
    transform: "translate(-163.062 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10414",
    "data-name": "Group 10414",
    transform: "translate(6.832 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33233",
    "data-name": "Path 33233",
    d: "M210.309,492.1h-1.891a.587.587,0,0,0-.238.034l-.216.278c-.017.017.068.034.187.034h1.925a.546.546,0,0,0,.238-.034l.182-.278C210.513,492.111,210.428,492.1,210.309,492.1Z",
    transform: "translate(-207.962 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10415",
    "data-name": "Group 10415",
    transform: "translate(9.393 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33234",
    "data-name": "Path 33234",
    d: "M255.388,492.1H253.5a.532.532,0,0,0-.233.034l-.182.278c-.011.017.074.034.193.034H255.2a.513.513,0,0,0,.233-.034l.148-.278C255.587,492.111,255.5,492.1,255.388,492.1Z",
    transform: "translate(-253.082 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10416",
    "data-name": "Group 10416",
    transform: "translate(2.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33235",
    "data-name": "Path 33235",
    d: "M125.012,487.727h3.145a.588.588,0,0,0,.238-.034l.131-.159c.017-.017-.068-.034-.182-.034h-3.106a.588.588,0,0,0-.238.034l-.165.159C124.813,487.716,124.892,487.727,125.012,487.727Z",
    transform: "translate(-124.832 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10417",
    "data-name": "Group 10417",
    transform: "translate(5.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33236",
    "data-name": "Path 33236",
    d: "M191.315,487.727h1.97a.533.533,0,0,0,.233-.034l.114-.159c.011-.017-.068-.034-.187-.034H191.5a.533.533,0,0,0-.233.034l-.131.159C191.116,487.716,191.2,487.727,191.315,487.727Z",
    transform: "translate(-191.135 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10418",
    "data-name": "Group 10418",
    transform: "translate(8.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33237",
    "data-name": "Path 33237",
    d: "M236.851,487.727h1.964a.481.481,0,0,0,.227-.034l.091-.159c.011-.017-.074-.034-.187-.034H237a.553.553,0,0,0-.233.034l-.108.159C236.647,487.716,236.732,487.727,236.851,487.727Z",
    transform: "translate(-236.662 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10419",
    "data-name": "Group 10419",
    transform: "translate(9.217 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33238",
    "data-name": "Path 33238",
    d: "M250.188,513.292h2.044c.125,0,.238-.017.244-.04l.153-.318c.011-.023-.079-.034-.2-.034h-2a.56.56,0,0,0-.244.034l-.193.318C249.973,513.275,250.064,513.292,250.188,513.292Z",
    transform: "translate(-249.983 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10420",
    "data-name": "Group 10420",
    transform: "translate(11.931 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33239",
    "data-name": "Path 33239",
    d: "M297.995,513.292h2.044a.457.457,0,0,0,.244-.04l.114-.318c.006-.023-.085-.034-.21-.034h-2a.56.56,0,0,0-.244.034l-.153.318C297.774,513.275,297.87,513.292,297.995,513.292Z",
    transform: "translate(-297.784 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10421",
    "data-name": "Group 10421",
    transform: "translate(10.807 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33240",
    "data-name": "Path 33240",
    d: "M280.425,506.135l.131-.3c.006-.017-.085-.034-.2-.034h-1.964a.546.546,0,0,0-.238.034l-.165.3c-.011.023.08.034.2.034h2A.493.493,0,0,0,280.425,506.135Z",
    transform: "translate(-277.983 -505.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10422",
    "data-name": "Group 10422",
    transform: "translate(13.471 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33241",
    "data-name": "Path 33241",
    d: "M327.337,506.135l.091-.3c.006-.017-.085-.034-.21-.034h-1.964a.494.494,0,0,0-.233.034l-.125.3c-.006.023.085.034.21.034h2A.48.48,0,0,0,327.337,506.135Z",
    transform: "translate(-324.896 -505.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10423",
    "data-name": "Group 10423",
    transform: "translate(10.376 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33242",
    "data-name": "Path 33242",
    d: "M270.554,498.834l-.17.29c-.011.017.079.034.2.034h1.964a.494.494,0,0,0,.233-.034l.136-.29c.011-.017-.079-.034-.2-.034h-1.925C270.668,498.8,270.566,498.811,270.554,498.834Z",
    transform: "translate(-270.383 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10424",
    "data-name": "Group 10424",
    transform: "translate(12.987 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33243",
    "data-name": "Path 33243",
    d: "M316.515,498.834l-.131.29c-.011.017.08.034.2.034h1.964a.513.513,0,0,0,.233-.034l.1-.29c.006-.017-.085-.034-.2-.034h-1.925C316.623,498.8,316.52,498.811,316.515,498.834Z",
    transform: "translate(-316.383 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10425",
    "data-name": "Group 10425",
    transform: "translate(14.646 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33244",
    "data-name": "Path 33244",
    d: "M345.812,513.292h2.044c.125,0,.233-.017.238-.04l.074-.318c.006-.023-.091-.034-.216-.034h-2a.526.526,0,0,0-.238.034l-.114.318C345.59,513.275,345.687,513.292,345.812,513.292Z",
    transform: "translate(-345.596 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10426",
    "data-name": "Group 10426",
    transform: "translate(17.365 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33245",
    "data-name": "Path 33245",
    d: "M393.712,513.292h2.044c.125,0,.227-.017.233-.04l.034-.318c0-.023-.1-.034-.221-.034h-2a.476.476,0,0,0-.233.034l-.068.318C393.49,513.275,393.587,513.292,393.712,513.292Z",
    transform: "translate(-393.496 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10427",
    "data-name": "Group 10427",
    transform: "translate(16.128 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33246",
    "data-name": "Path 33246",
    d: "M374.137,506.135l.051-.3c.006-.017-.091-.034-.216-.034h-1.964a.463.463,0,0,0-.227.034l-.085.3c-.006.023.091.034.21.034h2C374.035,506.169,374.137,506.152,374.137,506.135Z",
    transform: "translate(-371.696 -505.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10428",
    "data-name": "Group 10428",
    transform: "translate(18.791 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33247",
    "data-name": "Path 33247",
    d: "M421.038,506.135l.011-.3c0-.017-.1-.034-.216-.034h-1.964a.463.463,0,0,0-.227.034l-.045.3c-.006.023.1.034.216.034h2C420.935,506.169,421.038,506.152,421.038,506.135Z",
    transform: "translate(-418.596 -505.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10429",
    "data-name": "Group 10429",
    transform: "translate(15.594 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33248",
    "data-name": "Path 33248",
    d: "M362.387,498.834l-.091.29c-.006.017.085.034.21.034h1.964a.463.463,0,0,0,.227-.034l.057-.29c.006-.017-.091-.034-.21-.034h-1.925C362.495,498.8,362.392,498.811,362.387,498.834Z",
    transform: "translate(-362.296 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10430",
    "data-name": "Group 10430",
    transform: "translate(18.2 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33249",
    "data-name": "Path 33249",
    d: "M408.253,498.834l-.057.29c-.006.017.091.034.21.034h1.964c.119,0,.221-.017.221-.034l.023-.29c0-.017-.1-.034-.21-.034H408.48C408.355,498.8,408.253,498.811,408.253,498.834Z",
    transform: "translate(-408.196 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10431",
    "data-name": "Group 10431",
    transform: "translate(11.954 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33250",
    "data-name": "Path 33250",
    d: "M300.444,492.1h-1.891a.5.5,0,0,0-.227.034l-.142.278c-.011.017.079.034.2.034h1.925a.463.463,0,0,0,.227-.034l.108-.278C300.648,492.111,300.557,492.1,300.444,492.1Z",
    transform: "translate(-298.183 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10432",
    "data-name": "Group 10432",
    transform: "translate(14.51 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33251",
    "data-name": "Path 33251",
    d: "M345.416,492.1h-1.891a.45.45,0,0,0-.221.034l-.108.278c-.006.017.085.034.2.034h1.925a.433.433,0,0,0,.221-.034l.074-.278C345.62,492.111,345.529,492.1,345.416,492.1Z",
    transform: "translate(-343.196 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10433",
    "data-name": "Group 10433",
    transform: "translate(17.065 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33252",
    "data-name": "Path 33252",
    d: "M390.376,492.1h-1.891a.45.45,0,0,0-.221.034l-.068.278c-.006.017.085.034.2.034h1.925a.433.433,0,0,0,.221-.034l.034-.278C390.586,492.111,390.49,492.1,390.376,492.1Z",
    transform: "translate(-388.196 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10434",
    "data-name": "Group 10434",
    transform: "translate(19.62 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33253",
    "data-name": "Path 33253",
    d: "M435.34,492.1H433.45a.42.42,0,0,0-.216.034l-.034.278c0,.017.091.034.21.034h1.925c.119,0,.216-.017.216-.034v-.278C435.551,492.111,435.454,492.1,435.34,492.1Z",
    transform: "translate(-433.2 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10435",
    "data-name": "Group 10435",
    transform: "translate(11.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33254",
    "data-name": "Path 33254",
    d: "M282.389,487.727h1.964a.5.5,0,0,0,.227-.034l.068-.159c.006-.017-.079-.034-.193-.034h-1.942a.5.5,0,0,0-.227.034l-.091.159C282.19,487.716,282.275,487.727,282.389,487.727Z",
    transform: "translate(-282.195 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10436",
    "data-name": "Group 10436",
    transform: "translate(13.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33255",
    "data-name": "Path 33255",
    d: "M328.076,487.727h1.964a.45.45,0,0,0,.221-.034l.051-.159c.006-.017-.085-.034-.2-.034h-1.942a.451.451,0,0,0-.221.034l-.068.159C327.872,487.716,327.957,487.727,328.076,487.727Z",
    transform: "translate(-327.882 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10437",
    "data-name": "Group 10437",
    transform: "translate(16.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33256",
    "data-name": "Path 33256",
    d: "M373.595,487.727h1.964c.114,0,.216-.017.216-.034l.028-.159c.006-.017-.085-.034-.2-.034h-1.942a.421.421,0,0,0-.216.034l-.045.159C373.39,487.716,373.481,487.727,373.595,487.727Z",
    transform: "translate(-373.396 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10438",
    "data-name": "Group 10438",
    transform: "translate(18.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33257",
    "data-name": "Path 33257",
    d: "M419.11,487.727h1.964c.114,0,.21-.017.21-.034l.006-.159c0-.017-.091-.034-.2-.034h-1.942a.421.421,0,0,0-.216.034l-.028.159C418.9,487.716,418.991,487.727,419.11,487.727Z",
    transform: "translate(-418.9 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10439",
    "data-name": "Group 10439",
    transform: "translate(12.408 1.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33258",
    "data-name": "Path 33258",
    d: "M319.527,520.5H306.577c-.125,0-.238.017-.244.04l-.148.329c-.011.023.085.04.216.04h13.2c.131,0,.227-.017.227-.04l-.062-.329C319.76,520.517,319.652,520.5,319.527,520.5Z",
    transform: "translate(-306.184 -520.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10440",
    "data-name": "Group 10440",
    transform: "translate(26.206 1.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33259",
    "data-name": "Path 33259",
    d: "M551.471,520.5h-2.05c-.125,0-.221.017-.221.04h0l.068.329c.006.023.113.04.238.04H551.6c.131,0,.227-.017.221-.04h0l-.108-.329C551.7,520.517,551.6,520.5,551.471,520.5Z",
    transform: "translate(-549.2 -520.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10441",
    "data-name": "Group 10441",
    transform: "translate(28.936 1.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33260",
    "data-name": "Path 33260",
    d: "M599.562,520.5h-2.05c-.125,0-.221.017-.216.04h0l.108.329c.006.023.119.04.244.04h2.089c.131,0,.221-.017.216-.04h0l-.148-.329C599.8,520.517,599.686,520.5,599.562,520.5Z",
    transform: "translate(-597.296 -520.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10442",
    "data-name": "Group 10442",
    transform: "translate(31.667 1.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33261",
    "data-name": "Path 33261",
    d: "M648.933,520.5H645.6c-.125,0-.221.017-.21.04l.153.329a.484.484,0,0,0,.25.04h3.4c.131,0,.221-.017.2-.04l-.21-.329A.468.468,0,0,0,648.933,520.5Z",
    transform: "translate(-645.384 -520.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10443",
    "data-name": "Group 10443",
    transform: "translate(35.692 1.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33262",
    "data-name": "Path 33262",
    d: "M718.538,520.5h-2.05c-.125,0-.216.017-.2.04h0l.216.329a.512.512,0,0,0,.255.04h2.089c.131,0,.216-.017.2-.04h0l-.256-.329A.484.484,0,0,0,718.538,520.5Z",
    transform: "translate(-716.283 -520.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10444",
    "data-name": "Group 10444",
    transform: "translate(38.422 1.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33263",
    "data-name": "Path 33263",
    d: "M766.614,520.5h-2.05c-.125,0-.216.017-.2.04h0l.255.329a.559.559,0,0,0,.261.04h2.089c.131,0,.216-.017.2-.04h0l-.3-.329A.576.576,0,0,0,766.614,520.5Z",
    transform: "translate(-764.364 -520.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10445",
    "data-name": "Group 10445",
    transform: "translate(41.153 1.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33264",
    "data-name": "Path 33264",
    d: "M814.707,520.5h-2.05c-.125,0-.21.017-.193.04h0l.3.329a.589.589,0,0,0,.267.04h2.089c.131,0,.216-.017.193-.04h0l-.341-.329A.607.607,0,0,0,814.707,520.5Z",
    transform: "translate(-812.462 -520.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10446",
    "data-name": "Group 10446",
    transform: "translate(20.074 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33265",
    "data-name": "Path 33265",
    d: "M441.427,513.292h2.044c.125,0,.227-.017.227-.04l-.011-.318c0-.023-.1-.034-.227-.034h-2c-.125,0-.227.017-.227.034l-.028.318C441.206,513.275,441.3,513.292,441.427,513.292Z",
    transform: "translate(-441.2 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10447",
    "data-name": "Group 10447",
    transform: "translate(22.788 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33266",
    "data-name": "Path 33266",
    d: "M489.238,513.292h2.044c.125,0,.227-.017.221-.04l-.051-.318c-.006-.023-.108-.034-.227-.034h-2c-.125,0-.221.017-.221.034l.011.318C489.006,513.275,489.108,513.292,489.238,513.292Z",
    transform: "translate(-489 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10448",
    "data-name": "Group 10448",
    transform: "translate(21.454 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33267",
    "data-name": "Path 33267",
    d: "M467.941,506.135l-.028-.3c0-.017-.1-.034-.221-.034h-1.964c-.119,0-.221.017-.221.034l-.006.3c0,.023.1.034.221.034h2C467.845,506.169,467.941,506.152,467.941,506.135Z",
    transform: "translate(-465.5 -505.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10449",
    "data-name": "Group 10449",
    transform: "translate(24.077 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33268",
    "data-name": "Path 33268",
    d: "M514.175,506.135l-.068-.3a.463.463,0,0,0-.227-.034h-1.965c-.119,0-.216.017-.216.034l.028.3c0,.023.1.034.227.034h2C514.085,506.169,514.181,506.152,514.175,506.135Z",
    transform: "translate(-511.7 -505.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10450",
    "data-name": "Group 10450",
    transform: "translate(20.806 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33269",
    "data-name": "Path 33269",
    d: "M454.117,498.834l-.017.29c0,.017.1.034.216.034h1.964c.119,0,.216-.017.216-.034l-.017-.29c0-.017-.1-.034-.216-.034h-1.925C454.219,498.8,454.117,498.811,454.117,498.834Z",
    transform: "translate(-454.1 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10451",
    "data-name": "Group 10451",
    transform: "translate(23.395 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33270",
    "data-name": "Path 33270",
    d: "M499.7,498.834l.023.29c0,.017.1.034.221.034h1.964c.119,0,.216-.017.21-.034l-.057-.29a.432.432,0,0,0-.221-.034h-1.925C499.791,498.8,499.7,498.811,499.7,498.834Z",
    transform: "translate(-499.7 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10452",
    "data-name": "Group 10452",
    transform: "translate(29.316 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33271",
    "data-name": "Path 33271",
    d: "M606.54,506.135l-.148-.3a.527.527,0,0,0-.239-.034h-1.964c-.119,0-.216.017-.2.034l.108.3c.006.023.113.034.238.034h2C606.46,506.169,606.551,506.152,606.54,506.135Z",
    transform: "translate(-603.984 -505.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10453",
    "data-name": "Group 10453",
    transform: "translate(25.462 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33272",
    "data-name": "Path 33272",
    d: "M536.38,513.292h2.044c.125,0,.221-.017.216-.04l-.091-.318c-.006-.023-.108-.034-.233-.034h-2c-.125,0-.221.017-.216.034l.051.318C536.147,513.275,536.255,513.292,536.38,513.292Z",
    transform: "translate(-536.096 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10454",
    "data-name": "Group 10454",
    transform: "translate(28.135 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33273",
    "data-name": "Path 33273",
    d: "M583.514,513.292h2.044c.125,0,.221-.017.21-.04l-.131-.318c-.006-.023-.114-.034-.239-.034h-2c-.125,0-.221.017-.21.034l.1.318C583.281,513.275,583.389,513.292,583.514,513.292Z",
    transform: "translate(-583.184 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10455",
    "data-name": "Group 10455",
    transform: "translate(26.699 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33274",
    "data-name": "Path 33274",
    d: "M560.411,506.135l-.108-.3a.476.476,0,0,0-.233-.034h-1.964c-.119,0-.216.017-.21.034l.068.3c.006.023.108.034.233.034h2C560.32,506.169,560.417,506.152,560.411,506.135Z",
    transform: "translate(-557.896 -505.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10456",
    "data-name": "Group 10456",
    transform: "translate(25.962 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33275",
    "data-name": "Path 33275",
    d: "M544.9,498.834l.057.29a.445.445,0,0,0,.227.034h1.964c.119,0,.216-.017.21-.034l-.091-.29a.463.463,0,0,0-.227-.034h-1.925C544.991,498.8,544.9,498.811,544.9,498.834Z",
    transform: "translate(-544.9 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10457",
    "data-name": "Group 10457",
    transform: "translate(28.533 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33276",
    "data-name": "Path 33276",
    d: "M590.2,498.834l.1.29a.476.476,0,0,0,.233.034h1.964c.119,0,.21-.017.2-.034l-.131-.29a.494.494,0,0,0-.233-.034h-1.925C590.281,498.8,590.19,498.811,590.2,498.834Z",
    transform: "translate(-590.196 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10458",
    "data-name": "Group 10458",
    transform: "translate(22.175 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33277",
    "data-name": "Path 33277",
    d: "M480.3,492.1H478.41c-.114,0-.21.017-.21.034v.278c0,.017.1.034.216.034h1.925c.119,0,.21-.017.21-.034l-.034-.278C480.511,492.111,480.414,492.1,480.3,492.1Z",
    transform: "translate(-478.2 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10459",
    "data-name": "Group 10459",
    transform: "translate(24.695 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33278",
    "data-name": "Path 33278",
    d: "M524.691,492.1H522.8c-.114,0-.21.017-.2.034l.04.278c0,.017.1.034.221.034h1.919c.119,0,.21-.017.2-.034l-.074-.278C524.907,492.111,524.81,492.1,524.691,492.1Z",
    transform: "translate(-522.596 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10460",
    "data-name": "Group 10460",
    transform: "translate(27.211 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33279",
    "data-name": "Path 33279",
    d: "M569,492.1H567.1c-.114,0-.2.017-.2.034l.074.278a.45.45,0,0,0,.221.034h1.925c.119,0,.21-.017.2-.034l-.108-.278C569.211,492.111,569.114,492.1,569,492.1Z",
    transform: "translate(-566.9 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10461",
    "data-name": "Group 10461",
    transform: "translate(29.731 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33280",
    "data-name": "Path 33280",
    d: "M613.385,492.1h-1.891c-.114,0-.2.017-.2.034l.114.278a.463.463,0,0,0,.227.034h1.925c.119,0,.2-.017.2-.034l-.148-.278C613.607,492.111,613.5,492.1,613.385,492.1Z",
    transform: "translate(-611.296 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10462",
    "data-name": "Group 10462",
    transform: "translate(21.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33281",
    "data-name": "Path 33281",
    d: "M464.71,487.727h1.964c.114,0,.21-.017.21-.034l-.017-.159c0-.017-.1-.034-.21-.034h-1.942c-.114,0-.21.017-.21.034l-.006.159C464.5,487.716,464.6,487.727,464.71,487.727Z",
    transform: "translate(-464.5 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10463",
    "data-name": "Group 10463",
    transform: "translate(23.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33282",
    "data-name": "Path 33282",
    d: "M510.127,487.727h1.964c.114,0,.2-.017.2-.034l-.034-.159a.42.42,0,0,0-.216-.034H510.1c-.114,0-.2.017-.2.034l.017.159C509.911,487.716,510.008,487.727,510.127,487.727Z",
    transform: "translate(-509.9 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10464",
    "data-name": "Group 10464",
    transform: "translate(26.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33283",
    "data-name": "Path 33283",
    d: "M555.251,487.727h1.964c.114,0,.2-.017.2-.034l-.057-.159a.433.433,0,0,0-.221-.034h-1.942c-.114,0-.2.017-.2.034l.04.159C555.036,487.716,555.138,487.727,555.251,487.727Z",
    transform: "translate(-554.996 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10465",
    "data-name": "Group 10465",
    transform: "translate(29.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33284",
    "data-name": "Path 33284",
    d: "M600.48,487.727h1.964c.114,0,.2-.017.193-.034l-.08-.159a.469.469,0,0,0-.221-.034h-1.942c-.114,0-.2.017-.2.034l.057.159C600.264,487.716,600.36,487.727,600.48,487.727Z",
    transform: "translate(-600.196 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10466",
    "data-name": "Group 10466",
    transform: "translate(34.562 1.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33285",
    "data-name": "Path 33285",
    d: "M696.383,505.734l.187.3a.5.5,0,0,0,.244.034h2c.125,0,.21-.017.2-.034l-.227-.3a.6.6,0,0,0-.244-.034h-1.964C696.457,505.7,696.372,505.717,696.383,505.734Z",
    transform: "translate(-696.382 -505.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10467",
    "data-name": "Group 10467",
    transform: "translate(30.804 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33286",
    "data-name": "Path 33286",
    d: "M630.576,513.292h2.044c.125,0,.216-.017.2-.04l-.17-.318c-.011-.023-.119-.034-.244-.034h-2c-.125,0-.216.017-.21.034l.136.318A.457.457,0,0,0,630.576,513.292Z",
    transform: "translate(-630.196 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10468",
    "data-name": "Group 10468",
    transform: "translate(33.478 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33287",
    "data-name": "Path 33287",
    d: "M681.423,512.9h-3.935c-.125,0-.216.017-.2.034l.176.318a.485.485,0,0,0,.25.04h4.014c.125,0,.216-.017.2-.04l-.244-.318A.652.652,0,0,0,681.423,512.9Z",
    transform: "translate(-677.283 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10469",
    "data-name": "Group 10469",
    transform: "translate(31.94 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33288",
    "data-name": "Path 33288",
    d: "M652.791,506.135l-.187-.3a.546.546,0,0,0-.238-.034H650.4c-.119,0-.21.017-.2.034l.148.3c.011.023.119.034.238.034h2C652.711,506.169,652.8,506.152,652.791,506.135Z",
    transform: "translate(-650.196 -505.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10470",
    "data-name": "Group 10470",
    transform: "translate(31.104 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33289",
    "data-name": "Path 33289",
    d: "M635.484,498.834l.136.29a.513.513,0,0,0,.233.034h1.964c.119,0,.21-.017.2-.034l-.17-.29a.512.512,0,0,0-.233-.034h-1.93C635.564,498.8,635.473,498.811,635.484,498.834Z",
    transform: "translate(-635.483 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10471",
    "data-name": "Group 10471",
    transform: "translate(33.676 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33290",
    "data-name": "Path 33290",
    d: "M682.9,498.8h-1.925c-.119,0-.2.017-.193.034l.17.29a.546.546,0,0,0,.238.034h1.964c.119,0,.21-.017.193-.034l-.2-.29A.512.512,0,0,0,682.9,498.8Z",
    transform: "translate(-680.782 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10472",
    "data-name": "Group 10472",
    transform: "translate(38.081 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33291",
    "data-name": "Path 33291",
    d: "M760.567,512.9h-2.01c-.125,0-.21.017-.193.034h0l.244.318a.529.529,0,0,0,.255.04h2.044c.125,0,.21-.017.193-.04h0l-.284-.318A.594.594,0,0,0,760.567,512.9Z",
    transform: "translate(-758.362 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10473",
    "data-name": "Group 10473",
    transform: "translate(40.759 1.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33292",
    "data-name": "Path 33292",
    d: "M807.736,512.9h-2.01c-.125,0-.21.017-.187.034h0l.29.318a.559.559,0,0,0,.261.04h2.044c.125,0,.21-.017.187-.04h0l-.324-.318A.738.738,0,0,0,807.736,512.9Z",
    transform: "translate(-805.535 -512.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10474",
    "data-name": "Group 10474",
    transform: "translate(40.386 1.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33293",
    "data-name": "Path 33293",
    d: "M801.116,505.7h-1.964c-.119,0-.2.017-.187.034h0l.278.3a.556.556,0,0,0,.255.034h2c.125,0,.2-.017.187-.034h0l-.312-.3A.763.763,0,0,0,801.116,505.7Z",
    transform: "translate(-798.962 -505.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10475",
    "data-name": "Group 10475",
    transform: "translate(40.023 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33294",
    "data-name": "Path 33294",
    d: "M794.674,498.8h-1.93c-.119,0-.2.017-.182.034h0l.267.29a.638.638,0,0,0,.25.034h1.964c.119,0,.2-.017.182-.034h0l-.3-.29A.559.559,0,0,0,794.674,498.8Z",
    transform: "translate(-792.56 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10476",
    "data-name": "Group 10476",
    transform: "translate(36.237 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33295",
    "data-name": "Path 33295",
    d: "M729.216,498.8h-3.14c-.119,0-.2.017-.193.034l.21.29a.58.58,0,0,0,.244.034h.341a.228.228,0,0,1,.113.017l.267.358a.525.525,0,0,0,.25.034H729.9c.125,0,.21-.017.193-.034l-.63-.7A.559.559,0,0,0,729.216,498.8Z",
    transform: "translate(-725.882 -498.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10477",
    "data-name": "Group 10477",
    transform: "translate(39.365 0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33296",
    "data-name": "Path 33296",
    d: "M783.106,487.6h-1.942c-.114,0-.193.017-.182.034l.142.159a.588.588,0,0,0,.238.034h1.964c.113,0,.193-.017.176-.034l-.165-.159A.494.494,0,0,0,783.106,487.6Z",
    transform: "translate(-780.981 -487.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10478",
    "data-name": "Group 10478",
    transform: "translate(32.252 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33297",
    "data-name": "Path 33297",
    d: "M655.7,492.134l.148.278a.513.513,0,0,0,.233.034H658c.119,0,.2-.017.193-.034l-.182-.278a.512.512,0,0,0-.233-.034h-1.891C655.775,492.1,655.69,492.111,655.7,492.134Z",
    transform: "translate(-655.695 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10479",
    "data-name": "Group 10479",
    transform: "translate(34.772 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33298",
    "data-name": "Path 33298",
    d: "M700.271,492.1c-.114,0-.2.017-.187.034l.182.278a.546.546,0,0,0,.238.034h4.349c.119,0,.2-.017.182-.034l-.25-.278a.587.587,0,0,0-.238-.034Z",
    transform: "translate(-700.082 -492.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10480",
    "data-name": "Group 10480",
    transform: "translate(31.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33299",
    "data-name": "Path 33299",
    d: "M645.7,487.727h1.964c.114,0,.2-.017.187-.034l-.1-.159a.5.5,0,0,0-.227-.034h-1.942c-.114,0-.2.017-.193.034l.079.159C645.486,487.716,645.589,487.727,645.7,487.727Z",
    transform: "translate(-645.395 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10481",
    "data-name": "Group 10481",
    transform: "translate(34.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33300",
    "data-name": "Path 33300",
    d: "M691.012,487.727h1.964c.113,0,.2-.017.187-.034l-.119-.159a.533.533,0,0,0-.233-.034H690.87c-.113,0-.2.017-.187.034l.1.159C690.791,487.716,690.893,487.727,691.012,487.727Z",
    transform: "translate(-690.682 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10482",
    "data-name": "Group 10482",
    transform: "translate(36.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33301",
    "data-name": "Path 33301",
    d: "M736.122,487.727h1.964c.114,0,.2-.017.182-.034l-.142-.159a.567.567,0,0,0-.238-.034h-1.942c-.114,0-.2.017-.182.034l.119.159A.5.5,0,0,0,736.122,487.727Z",
    transform: "translate(-735.762 -487.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10483",
    "data-name": "Group 10483",
    transform: "translate(39.676 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33302",
    "data-name": "Path 33302",
    d: "M788.536,492.1h-1.891c-.113,0-.2.017-.182.034h0l.255.278a.6.6,0,0,0,.244.034h1.925c.119,0,.2-.017.182-.034h0l-.29-.278A.545.545,0,0,0,788.536,492.1Z",
    transform: "translate(-786.462 -492.1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10485",
    "data-name": "Group 10485",
    transform: "translate(16.281 9.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33303",
    "data-name": "Path 33303",
    d: "M331.523,535.8h-1.476a.055.055,0,0,0-.051.034l-.079.182a.053.053,0,0,0,.051.074h1.516a.055.055,0,0,0,.051-.04l.04-.182A.053.053,0,0,0,331.523,535.8Z",
    transform: "translate(-312.105 -505.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33304",
    "data-name": "Path 33304",
    d: "M68.556,41.447A.171.171,0,0,0,68.5,41.3l-.551-.522h0l-.369-.352c-.017-.244-.3-.335-.369-.352l-.4-.38h0l-3.441-3.276c-.006-.006-.006-.006-.011-.006V10.9a1.1,1.1,0,0,0-1.1-1.1H22.505a1.1,1.1,0,0,0-1.1,1.1V36.428l-5.07,4.866a.171.171,0,0,0-.057.148h0v.539a.193.193,0,0,0,.2.193h.011a10.443,10.443,0,0,0,3.861.642H64.479a10.5,10.5,0,0,0,3.861-.642h.017a.191.191,0,0,0,.193-.193l.006-.534Zm-3.662-1.164L66.972,40l.67.636-2.742-.25A.051.051,0,0,1,64.894,40.283ZM25.838,36.536ZM62.481,10.8V34.463H22.21V10.8Zm-21.194-.358a.091.091,0,1,1,.091.091A.09.09,0,0,1,41.287,10.442Zm.942,0a.182.182,0,1,1,.363,0,.187.187,0,0,1-.182.182A.179.179,0,0,1,42.229,10.442ZM58.961,36.536h0a.124.124,0,0,1-.017.028A.124.124,0,0,0,58.961,36.536ZM21.58,10.9a.926.926,0,0,1,.925-.925h39.76a.926.926,0,0,1,.925.925v25.47h-4.27l-.085-.307c0-.006-.006-.011-.011-.017h0c-.006-.006-.011-.011-.017-.011h3.429a.838.838,0,0,0,.84-.84V10.941a.838.838,0,0,0-.84-.84h-39.7a.838.838,0,0,0-.84.84V35.19a.838.838,0,0,0,.84.84H26c-.006.006-.011.006-.017.011h0c-.006.006-.011.011-.011.017l-.091.307h-4.3ZM20.251,39.074l2.231-2.248a.169.169,0,0,1,.114-.045H62.135a.143.143,0,0,1,.114.051l2.2,2.248a.163.163,0,0,1-.114.278H20.37A.17.17,0,0,1,20.251,39.074Zm31.613,2.294H32.906a.255.255,0,0,1-.238-.346l.534-1.346a.254.254,0,0,1,.238-.159H51.324a.26.26,0,0,1,.238.159l.534,1.346A.25.25,0,0,1,51.864,41.367Zm16.522.619a.024.024,0,0,1-.023.023H16.476c-.011,0-.028-.011-.028-.023v-.369H68.38v.369Z",
    transform: "translate(-16.281 -9.8)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasmIcon);
export default __webpack_public_path__ + "static/media/basm-icon.b041794c957667786b427914a44ae405.svg";
export { ForwardRef as ReactComponent };